import React from "react";
import { connect } from "react-redux";
import { Field, Form, Formik } from "formik";
import queryString from "query-string";
import * as Yup from "yup";
import ReactSwitch from "react-switch";
import {
  ErrorMessage,
  history,
  LoadingBoton,
  MyToolTip,
  TIPO_ENVIO,
  TIPO_REPUESTO,
  TIPO_REPUESTO_ID,
} from "../../../_helpers";

import { productoActions } from "../../../_actions";
import { busquedaActions } from "../../../_actions/busqueda.actions";
import alertService from "../../../_services/cart/alert.service";
import { NavBarLateral } from "../NavBarLateral";

/** Repuestos que, si se crea el Motor 04, se ofrecen como parte del mismo. */
const REPUESTOS_DE_MOTOR = [
  TIPO_REPUESTO.TURBO_COMPRESOR,
  TIPO_REPUESTO.ALTERNADOR,
  TIPO_REPUESTO.BURRO_ARRANQUE,
  TIPO_REPUESTO.BOMBA_AGUA,
  TIPO_REPUESTO.VOLANTE_MOTOR,
  TIPO_REPUESTO.BOBINA_ENCENDIDO,
];

class FormRepuestoDeBaja extends React.Component {
  state = {
    grabando: false,
    filtro: "",
  };

  /*
   * initialValues tiene que ser ESTABLE entre renders: Formik se guarda la
   * referencia y, si el objeto deja de ser igual al guardado, resetea el
   * formulario. Por eso se memoiza por (baja + tipos de repuesto) y por eso
   * ningun handler muta values en el lugar: mutar values muta tambien el
   * initialValues guardado y el proximo render descarta todo lo tildado.
   */
  initKey = null;
  initValues = null;

  /** Igual que FormProducto: desde /admin se opera a nombre del vendedor del query. */
  get esAdmin() {
    return (this.props.location?.pathname || "").startsWith("/admin");
  }

  get vendedorId() {
    return queryString.parse(this.props.location.search).vendedorId;
  }

  setGrabando = (grabando) => {
    this.setState({ grabando: grabando });
  };

  volver = () => {
    history.push(this.esAdmin ? "/admin/publicaciones" : "/vendedor/productos");
  };

  handleSuccess = () => {
    this.volver();
  };

  componentDidMount() {
    let params = queryString.parse(this.props.location.search);
    const { producto } = this.props;
    if (
      (producto === undefined || producto.id !== params.id) &&
      params.id !== undefined
    ) {
      if (this.esAdmin) {
        this.props.buscarYSeleccionarProductoBackOffice(params.id);
      } else {
        this.props.buscarYSeleccionarProductoAdmin(params.id);
      }
    }

    const { filtros } = this.props;

    if (filtros === undefined) this.props.traerFiltros();
  }

  /** Tipos de repuesto partidos en: los sueltos y los que van dentro del Motor 04. */
  separarTipoRepuestos() {
    const { filtros } = this.props;
    const tipoRepuestos = filtros?.tipoRepuestos || [];

    return {
      sueltos: tipoRepuestos.filter(
        (it) =>
          it.nombre !== TIPO_REPUESTO.AUTO_DESARMADERO &&
          it.nombre !== TIPO_REPUESTO.MOTOR_04 &&
          !REPUESTOS_DE_MOTOR.includes(it.nombre)
      ),
      deMotor: tipoRepuestos.filter((it) =>
        REPUESTOS_DE_MOTOR.includes(it.nombre)
      ),
    };
  }

  /** Memoizado: ver el comentario de initKey. */
  getInitialValues(producto, sueltos, deMotor) {
    const key = [
      producto?.id,
      sueltos.map((it) => it.id).join("-"),
      deMotor.map((it) => it.id).join("-"),
    ].join("|");

    if (this.initKey !== key) {
      this.initKey = key;
      this.initValues = {
        motor: {
          tipoRepuesto: {
            id: TIPO_REPUESTO_ID.MOTOR_04,
            nombre: TIPO_REPUESTO.MOTOR_04,
          },
          precio: "",
          productoBaja: { id: producto?.id },
          motorAsociados: deMotor.map((it) => ({
            create: true,
            tipoRepuesto: it,
          })),
        },
        crear04: true,
        /*
         * Que hacer con las que se eligen sin precio. Arranca prendido: cargar una
         * baja es justamente el momento en que todavia no hay precio por repuesto,
         * y dejarlas pausadas es publicarlas para nadie. El que quiera el
         * comportamiento viejo lo apaga acá.
         */
        aConsultar: true,
        productos: sueltos.map((it) => this.nuevoProducto(it, producto?.id)),
      };
    }

    return this.initValues;
  }

  nuevoProducto = (tipoRepuesto, bajaId) => ({
    tipoRepuesto: tipoRepuesto,
    create: false,
    precio: "",
    productoBaja: { id: bajaId !== undefined ? bajaId : this.props.producto?.id },
  });

  seleccionar = (setFieldValue, productos, value) => {
    setFieldValue(
      "productos",
      productos.map((it) => ({ ...it, create: value }))
    );
  };

  /**
   * Al prender el Motor 04 sus repuestos pasan a estar adentro (salen de la
   * grilla); al apagarlo vuelven a la grilla como publicaciones sueltas.
   */
  on04Cambio = (crear04, setFieldValue, values, deMotor) => {
    if (crear04) {
      const idsMotor = deMotor.map((it) => it.id);

      setFieldValue(
        "motor.motorAsociados",
        deMotor.map((it) => ({ create: true, tipoRepuesto: it }))
      );
      setFieldValue(
        "productos",
        values.productos.filter((it) => !idsMotor.includes(it.tipoRepuesto.id))
      );
    } else {
      const idsEnGrilla = values.productos.map((it) => it.tipoRepuesto.id);

      setFieldValue("motor.motorAsociados", []);
      setFieldValue(
        "productos",
        values.productos.concat(
          deMotor
            .filter((it) => !idsEnGrilla.includes(it.id))
            .map((it) => this.nuevoProducto(it))
        )
      );
    }
  };

  /**
   * Un repuesto de motor esta adentro del Motor 04 o suelto en la grilla,
   * nunca en los dos lados.
   */
  onMotorAsociadoCambio = (dentroDel04, idx, setFieldValue, values) => {
    const asociado = values.motor.motorAsociados[idx];

    setFieldValue(
      "motor.motorAsociados",
      values.motor.motorAsociados.map((it, i) =>
        i === idx ? { ...it, create: dentroDel04 } : it
      )
    );

    if (dentroDel04) {
      setFieldValue(
        "productos",
        values.productos.filter(
          (it) => it.tipoRepuesto.id !== asociado.tipoRepuesto.id
        )
      );
    } else if (
      !values.productos.some(
        (it) => it.tipoRepuesto.id === asociado.tipoRepuesto.id
      )
    ) {
      setFieldValue(
        "productos",
        values.productos.concat([this.nuevoProducto(asociado.tipoRepuesto)])
      );
    }
  };

  /** El input vacio da "", y el backend espera un BigDecimal o null. */
  normalizarPrecio(precio) {
    return precio === "" || precio === undefined ? null : precio;
  }

  /** Con precio la publicacion sale a la venta; sin precio depende de "a consultar". */
  tienePrecio(precio) {
    return Number(precio) > 0;
  }

  /**
   * Mismo criterio que el backend (Producto.setDataFromBajaDTO): la publicacion se
   * crea siempre, y queda ACTIVA si tiene precio o si va como "a consultar".
   */
  quedaActiva(precio, aConsultar) {
    return this.tienePrecio(precio) || aConsultar === true;
  }

  renderEstado(precio, aConsultar) {
    const conPrecio = this.tienePrecio(precio);
    const activa = this.quedaActiva(precio, aConsultar);

    return (
      <span
        className={
          "baja__estado " +
          (activa ? "baja__estado--activa" : "baja__estado--pausada")
        }
      >
        {conPrecio && "Queda activa"}
        {!conPrecio && activa && "Queda activa, a consultar"}
        {!activa && "Queda pausada"}
      </span>
    );
  }

  /**
   * El flag va solo en las que quedan sin precio: si el vendedor cargo un numero,
   * ese numero manda y la publicacion sale a la venta, tenga o no el switch puesto.
   */
  conPrecio(item, aConsultar) {
    const precio = this.normalizarPrecio(item.precio);

    return {
      ...item,
      precio: precio,
      precioAConsultar: aConsultar === true && !this.tienePrecio(precio),
    };
  }

  armarPayload(values) {
    let finalValues = [];

    if (values.crear04) {
      finalValues.push({
        ...this.conPrecio(values.motor, values.aConsultar),
        motorAsociados: values.motor.motorAsociados
          .filter((it) => it.create === true)
          .map((it) => it.tipoRepuesto),
      });
    }

    return finalValues.concat(
      values.productos
        .filter((it) => it.create === true)
        .map((it) => this.conPrecio(it, values.aConsultar))
    );
  }

  onSubmit = (values) => {
    const finalValues = this.armarPayload(values);

    if (finalValues.length === 0) {
      alertService.error("Elegi al menos una publicacion para crear");
      return;
    }

    this.props.grabar(
      finalValues,
      this.handleSuccess,
      this.setGrabando,
      this.esAdmin ? this.vendedorId : undefined
    );
  };

  render() {
    const { producto } = this.props;
    const { sueltos, deMotor } = this.separarTipoRepuestos();
    const cargandoTipos = sueltos.length === 0;
    const validationSchema = Yup.object().shape({});

    if (!producto) {
      return (
        <div className="dashboard">
          <NavBarLateral />
          <div className="dashboard__content"></div>
        </div>
      );
    }

    const filtro = this.state.filtro.trim().toLowerCase();
    /* Antes del JSX: initKey se calcula aca adentro y la usa el key del Formik. */
    const initialValues = this.getInitialValues(producto, sueltos, deMotor);

    return (
      <div className="dashboard">
        <NavBarLateral />
        <div className="dashboard__content">
          <Formik
            key={this.initKey}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={this.onSubmit}
          >
            {({ values, setFieldValue }) => {
              const elegidas = values.productos.filter((it) => it.create);
              const elegidos = elegidas.length;
              const seleccionadas = elegidos + (values.crear04 ? 1 : 0);
              const activas =
                elegidas.filter((it) =>
                  this.quedaActiva(it.precio, values.aConsultar)
                ).length +
                (values.crear04 &&
                this.quedaActiva(values.motor.precio, values.aConsultar)
                  ? 1
                  : 0);
              const pausadas = seleccionadas - activas;

              const visibles = values.productos
                .map((prod, idx) => ({ prod, idx }))
                .filter(
                  ({ prod }) =>
                    !filtro ||
                    prod.tipoRepuesto.nombre.toLowerCase().includes(filtro)
                );

              return (
                <Form>
                  <div className="dashboard__content-header">
                    <div className="dashboard__content-title">
                      <h2>Publicaciones de la baja</h2>
                    </div>
                  </div>

                  <div className="dashboard__content-main baja">
                    <div className="baja__resumen">
                      <div className="baja__resumen-auto">
                        <span className="baja__resumen-marca">
                          {producto.marca?.nombre} {producto.modelo?.nombre}
                        </span>
                        <span className="baja__resumen-version">
                          {producto.version?.nombre}
                          {producto.anio ? " - " + producto.anio : ""}
                        </span>
                        {/* El envio no se elige acá: se hereda de la baja. */}
                        <span className="baja__resumen-envio">
                          {producto.tipoEnvio === TIPO_ENVIO.ENVIO_A_COORDINAR
                            ? "Envio a coordinar"
                            : "Sin envio"}
                          <MyToolTip
                            texto="Las publicaciones que se creen acá usan el tipo de envío de la baja. Para cambiarlo, editá la baja."
                            id="baja-envio"
                          />
                        </span>
                      </div>
                      <p className="baja__resumen-ayuda">
                        Elegi que repuestos de esta baja queres publicar.{" "}
                        <strong>
                          El precio no es obligatorio: la publicacion se crea
                          igual.
                        </strong>{" "}
                        Con precio queda <strong>activa</strong> y a la venta;
                        sin precio sale <strong>a consultar</strong>, se ve en
                        el sitio y te pueden preguntar. Si apagas esa opcion,
                        las que no tengan precio se crean{" "}
                        <strong>pausadas</strong> y no se ven hasta que les
                        cargues el precio. Todas se pueden editar despues para
                        agregar detalle o fotos.
                      </p>

                      <label className="baja__toggle baja__resumen-aconsultar">
                        <ReactSwitch
                          onChange={(event) =>
                            setFieldValue("aConsultar", event)
                          }
                          checked={values.aConsultar}
                          onColor="#FF962E"
                          height={22}
                          width={44}
                        />
                        <span>
                          Publicar las que no tengan precio como{" "}
                          <strong>a consultar</strong>
                        </span>
                        <MyToolTip
                          texto="En vez de quedar pausadas, salen publicadas sin precio: se ven en el sitio y te pueden consultar, pero no se compran por el carrito ni se les promete envío."
                          id="baja-a-consultar"
                        />
                      </label>
                    </div>

                    <section className="baja__seccion">
                      <div className="baja__motor">
                        <div className="baja__motor-header">
                          <label className="baja__toggle">
                            <ReactSwitch
                              onChange={(event) => {
                                setFieldValue("crear04", event);
                                this.on04Cambio(
                                  event,
                                  setFieldValue,
                                  values,
                                  deMotor
                                );
                              }}
                              checked={values.crear04}
                              onColor="#FF962E"
                              height={22}
                              width={44}
                            />
                            <span className="baja__motor-titulo">
                              Publicar Motor 04
                            </span>
                          </label>
                          <MyToolTip
                            texto="El Motor 04 se publica como una sola unidad junto con los repuestos que dejes encendidos. Los que apagues se publican por separado."
                            id="baja-motor"
                          />
                        </div>

                        {values.crear04 && (
                          <div className="baja__motor-body">
                            <div className="baja__campo">
                              <label htmlFor="motor.precio">
                                Precio del Motor 04
                              </label>
                              <Field
                                id="motor.precio"
                                name="motor.precio"
                                type="number"
                                min="0"
                                inputMode="numeric"
                                placeholder="Opcional"
                              />
                              {this.renderEstado(values.motor.precio, values.aConsultar)}
                              <ErrorMessage name="motor.precio" />
                            </div>

                            <div className="baja__motor-partes">
                              <p className="baja__motor-partes-titulo">
                                Incluye estos repuestos
                                <MyToolTip
                                  texto="Apaga un repuesto para que no vaya dentro del Motor 04: pasa a la lista de abajo y se publica solo."
                                  id="baja-motor-partes"
                                />
                              </p>
                              <div className="baja__chips">
                                {values.motor.motorAsociados?.map(
                                  (repMotor, idx) => (
                                    <label
                                      key={repMotor.tipoRepuesto.id}
                                      className={
                                        "baja__chip" +
                                        (repMotor.create
                                          ? " baja__chip--on"
                                          : "")
                                      }
                                    >
                                      <ReactSwitch
                                        onChange={(event) =>
                                          this.onMotorAsociadoCambio(
                                            event,
                                            idx,
                                            setFieldValue,
                                            values
                                          )
                                        }
                                        checked={repMotor.create}
                                        onColor="#FF962E"
                                        height={18}
                                        width={36}
                                      />
                                      <span>
                                        {repMotor.tipoRepuesto.nombre}
                                      </span>
                                    </label>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </section>

                    <section className="baja__seccion">
                      <div className="baja__toolbar">
                        <div className="baja__toolbar-info">
                          <h4>Repuestos sueltos</h4>
                          <span className="baja__contador">
                            {elegidos} de {values.productos.length}{" "}
                            seleccionados
                          </span>
                        </div>
                        <div className="baja__toolbar-acciones">
                          <input
                            type="search"
                            className="baja__buscador"
                            placeholder="Buscar repuesto"
                            value={this.state.filtro}
                            onChange={(e) =>
                              this.setState({ filtro: e.target.value })
                            }
                          />
                          <button
                            className="button baja__boton-chico"
                            data-type="primary"
                            type="button"
                            onClick={() =>
                              this.seleccionar(
                                setFieldValue,
                                values.productos,
                                true
                              )
                            }
                          >
                            Seleccionar todo
                          </button>
                          <button
                            className="button baja__boton-chico"
                            data-type="complementary"
                            type="button"
                            onClick={() =>
                              this.seleccionar(
                                setFieldValue,
                                values.productos,
                                false
                              )
                            }
                          >
                            Quitar todo
                          </button>
                        </div>
                      </div>

                      {cargandoTipos && (
                        <p className="baja__vacio">Cargando repuestos...</p>
                      )}

                      {!cargandoTipos && visibles.length === 0 && (
                        <p className="baja__vacio">
                          Ningun repuesto coincide con la busqueda.
                        </p>
                      )}

                      <div className="baja__grilla">
                        {visibles.map(({ prod, idx }) => (
                          <div
                            key={prod.tipoRepuesto.id}
                            className={
                              "baja__item" + (prod.create ? " baja__item--on" : "")
                            }
                          >
                            <label className="baja__item-header">
                              <ReactSwitch
                                onChange={(event) =>
                                  setFieldValue(
                                    `productos[${idx}].create`,
                                    event
                                  )
                                }
                                checked={prod.create}
                                onColor="#FF962E"
                                height={22}
                                width={44}
                              />
                              <span className="baja__item-nombre">
                                {prod.tipoRepuesto.nombre}
                              </span>
                            </label>
                            <div className="baja__item-precio">
                              <Field
                                name={`productos[${idx}].precio`}
                                type="number"
                                min="0"
                                inputMode="numeric"
                                disabled={!prod.create}
                                placeholder="Precio (opcional)"
                                aria-label={
                                  "Precio de " + prod.tipoRepuesto.nombre
                                }
                              />
                              {prod.create && this.renderEstado(prod.precio, values.aConsultar)}
                              <ErrorMessage name={`productos[${idx}].precio`} />
                            </div>
                          </div>
                        ))}
                      </div>
                    </section>
                  </div>

                  <div className="baja__barra">
                    <span className="baja__barra-total">
                      {seleccionadas === 0 ? (
                        "No hay publicaciones seleccionadas"
                      ) : (
                        <>
                          Se van a crear <strong>{seleccionadas}</strong>{" "}
                          {seleccionadas === 1
                            ? "publicacion"
                            : "publicaciones"}
                          {": "}
                          {activas} {activas === 1 ? "activa" : "activas"}
                          {/* Con "a consultar" prendido no queda ninguna pausada:
                              la frase de las pausadas sobra. */}
                          {pausadas > 0 && (
                            <>
                              {" "}
                              y {pausadas}{" "}
                              {pausadas === 1 ? "pausada" : "pausadas"} por no
                              tener precio
                            </>
                          )}
                          .
                        </>
                      )}
                    </span>
                    <div className="baja__barra-botones">
                      <button
                        className="button"
                        type="button"
                        data-type="complementary"
                        onClick={this.volver}
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={this.state.grabando || seleccionadas === 0}
                        className="button"
                        type="submit"
                        data-type="primary"
                      >
                        Guardar
                        <LoadingBoton grabando={this.state.grabando} />
                      </button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </div>
      </div>
    );
  }
}

function mapState(state) {
  const { producto, filtros } = state.busqueda;
  return { producto, filtros };
}

const actionCreators = {
  grabar: productoActions.grabarRepuestosBaja,
  traerFiltros: busquedaActions.traerFiltros,
  buscarYSeleccionarProductoAdmin:
    busquedaActions.buscarYSeleccionarProductoAdmin,
  buscarYSeleccionarProductoBackOffice:
    busquedaActions.buscarYSeleccionarProductoBackOffice,
};

const connectedFormRepuestoDeBaja = connect(
  mapState,
  actionCreators
)(FormRepuestoDeBaja);
export { connectedFormRepuestoDeBaja as FormRepuestoDeBaja };
